import { Hide as ChakraHide, HideProps } from '@chakra-ui/react';

/** The same as Chakra's `Hide`, but with the SSR option defaulting to false so that it returns the correct value on the first render. */
export const Hide = ({ ssr = false, ...props }: HideProps) => {
  return <ChakraHide ssr={ssr} {...props} />;
};
